import { useCallback, useState } from 'react'

import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer'
import { clusterPath, shipClusterPath } from '../utils/markers'

export default function useCluster() {
  const [cluster, setCluster] = useState<MarkerClusterer>()
  const [shipCluster, setShipCluster] = useState<MarkerClusterer>()
  const createCluster = useCallback((markers: Array<google.maps.Marker>, map: google.maps.Map) => {
    setCluster(
      new MarkerClusterer({
        map,
        markers,
        renderer: {
          render: ({ count, position }) => {
            return new google.maps.Marker({
              icon: {
                url: `data:image/svg+xml;base64,${clusterPath}`,
                scaledSize: new google.maps.Size(32, 32),
              },
              label: {
                text: count.toString(),
                color: 'white',
                fontFamily: 'Lato',
                fontSize: '14px',
                fontWeight: '400',
              },
              position,
            })
          },
        },
        algorithm: new SuperClusterAlgorithm({
          maxZoom: 8,
          radius: window.innerWidth > 1023 ? 200 : 100,
        }),
      }),
    )
  }, [])

  const createShipCluster = useCallback(
    (markers: Array<google.maps.Marker>, map: google.maps.Map) => {
      setShipCluster(
        new MarkerClusterer({
          map,
          markers,
          renderer: {
            render: ({ count, position }) => {
              return new google.maps.Marker({
                icon: {
                  url: `data:image/svg+xml;base64,${shipClusterPath}`,
                  scaledSize: new google.maps.Size(40, 40),
                },
                label: {
                  text: count.toString(),
                  color: 'white',
                  fontFamily: 'Lato',
                  fontSize: '14px',
                  fontWeight: '400',
                },
                position,
              })
            },
          },
          algorithm: new SuperClusterAlgorithm({ minZoom: 0, maxZoom: 17, radius: 10 }),
        }),
      )
    },
    [],
  )

  return { createCluster, cluster, shipCluster, createShipCluster }
}
